import { hslToHex } from "@/lib/colors";

/** Neutral defaults (HSL channel triplets, space-separated). Used by Stripe / PDFs. */
const light = {
  foreground: "222.2 84% 4.9%",
  border: "214.3 31.8% 91.4%",
  card: "0 0% 100%",
  muted: "210 40% 96.1%",
  primary: "222.2 47.4% 11.2%",
  primaryForeground: "210 40% 98%",
  mutedForeground: "215.4 16.3% 46.9%",
  background: "0 0% 100%",
} as const;

const shadows = {
  sm: "0 1px 2px 0 rgb(0 0 0 / 0.05)",
  md: "0 4px 6px -1px rgb(0 0 0 / 0.1), 0 2px 4px -2px rgb(0 0 0 / 0.1)",
  lg: "0 10px 15px -3px rgb(0 0 0 / 0.1), 0 4px 6px -4px rgb(0 0 0 / 0.1)",
  inset: "inset 0 1px 0 rgb(0 0 0 / 0.04)",
} as const;

/** Convert HSL channels to hex for APIs that require it (Stripe, NProgress). */
export function brandingHslToHex(channels: string): string {
  const normalized = channels.trim().replace(/\s+/g, " ");
  return hslToHex(`hsl(${normalized.replace(/ /g, ", ")})`);
}

export function getBrandingLight() {
  return light;
}

export function getBrandingShadows() {
  return shadows;
}
